import { useParams } from "react-router-dom"
import { useGetResponseByIdQuery } from "../../responses/responsesApiSlice"
import ResponseTextView from "../../../partial/ResponseTextView"
import ResponseCodeView from "../../../partial/ResponseCodeView"
import ResponseFileView from "../../../partial/ResponseFileView"
import AdditionListView from "../../../partial/AdditionListView"

const FriendResponse = () => {
  const { responseId, friendResponse} = useParams()
  const {
    data: response,
    isLoading,
    isSuccess,
    isError,
    error
} = useGetResponseByIdQuery({id:responseId})
  const type = response.action?.type || "Text"
  const currrentResponse = response.relatedResponses.find(res=>res._id === friendResponse)
  return (<>
    <span className='grid-results-header'>
    <div className='sticky'> ביצוע</div>
    </span>
       
    <span className='grid-results-data'>
       
    <>
                {type==="Text"&& <ResponseTextView  body={currrentResponse.body}  />}
                {type==="Code"&& <ResponseCodeView header={`${response.action?.title}-${response.action?.text}`} language={response.action?.language}  highlight={response.action?.highlight} body={currrentResponse.body}  />}
                {type==="File"&& <ResponseFileView  body={currrentResponse.body}  />}
              
            </>          
    </span>
    <AdditionListView additions={currrentResponse.additions} type={type} />
    <span className='grid-results-header'> הערות משתמש </span>
        <span className='grid-results-data'>
        <textarea readOnly
                    className={`form__input  form__input--comments  comments-area`}
                    id="comments"
                    name="comments"
                    value={currrentResponse.comments}
                    
                />        
            </span>
    </>
  )
}

export default FriendResponse